
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[categoryId]",
      function () {
        return require("private-next-pages/blog/category/[categoryId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[categoryId]"])
      });
    }
  